import React from "react";

/**
 * Global responsive image component με lazy loading & fixed height.
 * Αν θες να αλλάξεις global ύψος ή στυλ, το κάνεις μόνο εδώ.
 */
const OptimizedImage = ({
  src,
  alt = "",
  height = "250px",
  width = "100%",
  className = "",
  style = {},
  borderRadius = "10px",
}) => {
  if (!src) {
    // Αν δεν υπάρχει εικόνα, εμφανίζει placeholder
    return (
      <div
        className={`bg-secondary ${className}`}
        style={{
          width,
          height,
          borderRadius,
          ...style,
        }}
      ></div>
    );
  }

  return (
    <img
      src={src}
      alt={alt}
      loading="lazy"
      className={`img-fluid shadow-sm ${className}`}
      style={{
        width,
        height,
        objectFit: "cover",
        borderRadius,
        transition: "filter 0.3s ease",
        filter: "brightness(90%)",
        ...style,
      }}
      onError={(e) => {
        e.target.src = "/placeholder.jpg"; // ενα fallback image αν θες
      }}
    />
  );
};

export default OptimizedImage;
